import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('../views/List')
const Create = () => import('../views/Create')
const Display = () => import('../views/Display')
const Disabled = () => import('../views/Disabled')
const Published = () => import('../views/Published')
const Moderation = () => import('../views/Moderation')
const Updated = () => import('../views/Updated')

const ROUTE_NAME = 'profile:announcement:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const CREATE = p('create')
const UPDATE = p('update')
const DISPLAY = p('display')
const DISABLED = p('disabled')
const PUBLISHED = p('published')
const MODERATION = p('moderation')
const UPDATED = p('updated')

const withAnnouncement = r => ({ ...r.params, announcementType: 'announcement' })

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:VIEW'], options),
    }),
    route('create/', Create, CREATE, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:ADD'], options),
    }),
    route(':id/update/', Create, UPDATE, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:EDIT', 'ADS:ADS:EDIT_OWN'], options),
    }),
    route(':id/', Display, DISPLAY, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:VIEW'], options),
    }),
    route(':id/:identifier/disabled/', Disabled, DISABLED, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:ADD'], options),
    }),
    route(':id/:identifier/published/', Published, PUBLISHED, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:ADD'], options),
    }),
    route(':id/:identifier/moderation/', Moderation, MODERATION, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:ADD'], options),
    }),
    route(':id/:identifier/updated/', Updated, UPDATED, {
      props: withAnnouncement,
      meta: accessPermission(['ADS:ADS:ADD'], options),
    }),
    { path: '*', redirect: { name: LIST } },
  ]
}
